import React, { useContext } from 'react';
import { AuthClient } from '.';

export const AuthenticatedApiContext = React.createContext<AuthClient>({} as AuthClient);

export const useAuthenticatedApiContext = (): AuthClient => {
  return useContext(AuthenticatedApiContext);
};
